import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  locationBasedPickmeFoodListsPerMonth: [],
  addData: {},
  sorted: [],
  PickmeFoodListTypes: [],
};

const slice = createSlice({
  name: 'PickMeFoodList',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET PickmeFoodListManagement
    getAllPickmeFoodListTypesSuccess(state, action) {
      state.PickmeFoodListTypes = action.payload.data;
    },
    // GET PickmeFoodListManagement
    getPickmeFoodListsSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET PickmeFoodListManagement
    getAllPickmeFoodListsSuccess(state, action) {
      state.allData = action.payload.data;
    },
    // GET PickmeFoodListManagement
    locationBasedPickmeFoodListsPerMonthSuccess(state, action) {
      state.locationBasedPickmeFoodListsPerMonth = action.payload.data;
    },

    addOrUpdatePickmeFoodLists(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllPickmeFoodList() {
  return async () => {
    try {
      const response = await get(`PickmeFoodListAll`);
      if (response.status) {
        dispatch(slice.actions.getAllPickmeFoodListsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPickmeFoodList() {
  return async () => {
    try {
      const response = await get(`PickmeFoodList`);
      if (response.status) {
        dispatch(slice.actions.getPickmeFoodListsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function syncFoodListWithPickme(body) {
  return async () => {
    try {
      const response = await post(`syncFoodListWithPickme`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePickmeFoodLists(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePickmeFoodList(body) {
  return async () => {
    try {
      const response = await put(`PickmeFoodList`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePickmeFoodLists(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deletePickmeFoodList(body) {
  return async () => {
    try {
      const response = await deleteMethod(`PickmeFoodList`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePickmeFoodLists(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
